module.exports = __webpack_public_path__ + "img/icon (11).12819cd4.png";